import React from "react";
import { ESTADOS_INTERES } from "../constants/interesados";

export default function InteresadosFilters({
  filtros,
  setFiltros,
  limpiarFiltros,
  fuentesOptions = [],
  empresasOptions = [],
}) {
  return (
    <div className="management-card int-filters-card management-filters-card mb-4">
      <div className="int-filters-grid row g-3 align-items-end">
        <div className="col-12 col-md-3">
          <label className="form-label management-label">Buscar</label>
          <input
            type="text"
            className="form-control"
            placeholder="Nombre, documento, telefono o email"
            value={filtros.search}
            onChange={(e) => setFiltros((prev) => ({ ...prev, search: e.target.value }))}
          />
        </div>
        <div className="col-6 col-md-3">
          <label className="form-label management-label">Estado</label>
          <select
            className="form-select"
            value={filtros.estado}
            onChange={(e) => setFiltros((prev) => ({ ...prev, estado: e.target.value }))}
          >
            <option value="all">Todos</option>
            <option value="pendientes_coordinacion">Transferidos sin matricular</option>
            {ESTADOS_INTERES.map((estado) => (
              <option key={estado.value} value={estado.value}>
                {estado.label}
              </option>
            ))}
          </select>
        </div>
        <div className="col-6 col-md-3">
          <label className="form-label management-label">Fuente de origen</label>
          <select
            className="form-select"
            value={filtros.fuente}
            onChange={(e) => {
              const value = e.target.value;
              const selected = fuentesOptions.find((fuente) => String(fuente.value) === String(value));
              setFiltros((prev) => ({
                ...prev,
                fuente: value,
                fuenteLabel: selected?.label || "",
              }));
            }}
          >
            <option value="all">Todas</option>
            {fuentesOptions.map((fuente) => (
              <option key={fuente.value} value={fuente.value}>
                {fuente.label}
              </option>
            ))}
          </select>
        </div>
        <div className="col-6 col-md-3">
          <label className="form-label management-label">Empresa</label>
          <div className="input-group">
            <select
              className="form-select"
              value={filtros.empresa}
              onChange={(e) => setFiltros((prev) => ({ ...prev, empresa: e.target.value }))}
            >
              <option value="all">Todas</option>
              {empresasOptions.map((empresa) => (
                <option key={empresa.value} value={empresa.value}>
                  {empresa.label}
                </option>
              ))}
            </select>
            <button type="button" className="btn management-btn-primary management-btn-tiny" onClick={limpiarFiltros}>
              <i className="bi bi-eraser me-1" />
              Limpiar
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
